import { gql } from '@apollo/client';

export const AscProjectApprovedStatusFragment = gql`
  fragment AscProjectApprovedStatus on AscProjectApprovalStatusResult {
    ascProjectId
    fiscalYearId
    periodName
    status
    periodApprovalByUserId
    periodApprovalDatetime
    periodApprovalComment
    approvedThroughMonthYear
  }
`;
